import type React from 'react'
import type { ComponentPropsWithoutRef } from 'react'
import { Rating as CssModulesRating } from '@sunwebgroup/uds-ui/rating'
import { styled } from 'styled-components'

export interface RatingProps extends ComponentPropsWithoutRef<'div'> {
  /**
   * Rating value between 0.5 and 5 with 0.5 steps.
   * Allowed values: 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5.
   * The component renders full stars for the integer part and
   * a half star for a half rating (0.5).
   */
  rating: number
  /**
   * Color of the stars.
   */
  type?: 'neutral' | 'yellow'
}

const StyledRating = styled(CssModulesRating)``

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/rating' instead.
 */
export default function RatingWrapper(props: RatingProps): React.JSX.Element | null {
  return <StyledRating {...props} />
}
